import { ISalesFunnelStage } from '@user/store/salesFunnel/typings'
import { OPPORTUNITY_STATUSES, OppStatus } from '../OpportunityCard/typings'
import { useTheme } from '@mui/material/styles'

export const getOpportunityStatus = (
  stages: ISalesFunnelStage[],
  salesFunnelStageId: number,
): { status: OppStatus; percentage: number | null } => {
  const currentStage = stages
    .filter((stage) => stage.id == salesFunnelStageId)
    .shift()

  if (!currentStage) {
    return {
      percentage: null,
      status: OPPORTUNITY_STATUSES.Open,
    }
  } else {
    const { name } = currentStage

    switch (name) {
      case 'Closed/Won':
        return {
          percentage: 100,
          status: OPPORTUNITY_STATUSES.Won,
        }
      case 'Closed/Lost':
        return {
          percentage: 0,
          status: OPPORTUNITY_STATUSES.Lost,
        }
      default:
        return {
          percentage: getCompletionPercentage(stages, currentStage),
          status: OPPORTUNITY_STATUSES.Open,
        }
    }
  }
}

const getCompletionPercentage = (
  stages: ISalesFunnelStage[],
  currentStage: ISalesFunnelStage,
) => {
  const indexOfCurrentStage = stages.indexOf(currentStage)
  const percentage = Math.floor(
    ((indexOfCurrentStage + 1) / (stages.length - 1)) * 100,
  )

  if (percentage >= 0 && percentage <= 100) {
    return percentage
  } else {
    return null
  }
}

export const getColorByOpportunityStatus = (
  status: OppStatus,
  defaultColor?: string,
) => {
  const theme = useTheme()
  switch (status) {
    case OPPORTUNITY_STATUSES.Won:
      return '#E9F4FE'
    case OPPORTUNITY_STATUSES.Lost:
      return '#ffecec'
    default:
      return defaultColor || theme.palette.common.white
  }
}
